import React, { useState, useEffect, useRef } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  // OverlayTrigger,
  Row,
  Tooltip,
  Modal,
  // Tooltip,
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
// import swal from "sweetalert";
import { post, postFormData } from "../../../helpers/api_helper";
import { SVGICON } from "../../../constant/theme";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTagsInput from "../../../CustomControls/CustomTagsInput";
// import CustomMultiColumnSelect from "../../../CustomControls/CustomMultiColumnSelect";
import {
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetDepartmentDropDownList,
  POST_GetMachineParameters,
  POST_GetMachinesDropDownList,
  // POST_GetMaterialDropDownList,
  POST_GetParameterDetailByID,
  POST_GetTestMethodDropDownList,
  POST_ParameterInsert,
  POST_ParameterUpdate,
  POST_ProductGroupDropDownList,
  POST_TestMethodsInsert,
  POST_GetParameterSubParamtersMappingList,
  POST_ValidateFormulaExpression,
} from "../../../helpers/url_helper";
import {
  capitalizeString,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
  customConfirmDialog,
} from "../CommonFunctions";

import CustomTextArea from "../../../CustomControls/CustomTextArea";
import QuickAddTestMethod from "../TestMethod/QuickAddTestMethod";
import QuickAddCategory from "../Categories/QuickAddCategory";

const AddParameters = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  // const [materialOptionsList, setMaterialOptionsList] = useState([]);
  // const [materialOptions, setMaterialOptions] = useState([]);
  const [testMethodOptions, setTestMethodOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  // const getMaterialList = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetMaterialDropDownList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response.IsSuccess) {
  //         let optionsList = response.MaterialTypeList.map((item) => ({
  //           searchableText:
  //             item.ProductGroupName +
  //             " " +
  //             item.DepartmentName +
  //             " " +
  //             item.MaterialType,
  //           ProductGroupIDEncrypt: item.ProductGroupIDEncrypted,
  //           ProductGroupName: item.ProductGroupName,
  //           DepartmentIDEncrypt: item.DepartmentIDEncrypted,
  //           DepartmentName: item.DepartmentName,
  //           MaterialTypeIDEncrypt: item.MaterialTypeIDEncrypted,
  //           MaterialType: item.MaterialType,
  //           display: true,
  //         }));
  //         setMaterialOptions(optionsList);
  //         setMaterialOptionsList(optionsList);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const ParameterResultTypeOptions = [
    { label: "Quantitative", value: 1 },
    { label: "Qualitative", value: 2 },
  ];

  const getTestMethodList = async () => {
    setIsLoading(true);
    await post(POST_GetTestMethodDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response.IsSuccess) {
          setTestMethodOptions(
            response.TestMethodList.map((item) => ({
              label: item.NickName
                ? `${item.TestMethod} (${item.NickName})`
                : item.TestMethod,
              value: item.TestMethodIDEncrypted,
              NickName: item.NickName,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProductGroupDDL = async () => {
    setIsLoading(true);
    await post(POST_ProductGroupDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProductGroupOptions(
            response?.ProductGroupDropDownList?.map((item) => ({
              label: item.ProductGroupName,
              value: item.ProductGroupIDEncrypt,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getMachineParameterList = async () => {
    setIsLoading(true);
    await post(POST_GetMachineParameters, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response.IsSuccess) {
          formik.setFieldValue(
            "ParameterMachineMappingList",
            response.MachineParameterList.map((item) => ({
              ...item,
              IsSelected: false,
              display: true,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getParameterMachineLinkList = async () => {   // add mode only; edit mode gets the list from Parameters_DetailByID
    setIsLoading(true);
    await post(POST_GetMachinesDropDownList, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response.IsSuccess) {
          formik.setFieldValue(
            "ParameterMachineLinkList",
            (response.MachinesDropDownList || []).map((item) => ({
              MachineIDEncrypt: item.MachineIDEncrypt,
              MachineName: item.MachineName,
              IsSelected: false,
              display: true,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const initNABLTestMethodRange = {
    ParameterNABLTestMethodRangeIDEncrypted: "",
    ProductGroupIDEncrypt: "",
    TestMethodIDEncrypt: "",
    NABLRangeFrom: "",
    NABLRangeTo: "",
    ResultValidKeywords: [],
    IsDelete: false,
  };

  const validationSchema = Yup.object().shape({
    ParameterName: Yup.string()
      .trim()
      .required("Parameter Name is required field"),
    ParameterResultType: Yup.string()
      .trim()
      .required("Parameter Result Type is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ParameterIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      ParameterName: "",
      IsNABL: false,
      ParameterResultType: 1,
      // ParameterMaterialTypeList: [],
      ParameterMachineMappingList: [],
      ParameterMachineLinkList: [],
      // MaterialID: "",
      // MaterialText: "",
      // DepartmentIDEncrypt: "",
      // DepartmentName: "",
      // ProductGroupIDEncrypt: "",
      // ProductGroupName: "",
      // MaterialTypeIDEncrypt: "",
      // MaterialType: "",
      // TestMethodIDEncrypt: "",
      // TestMethodName: "",
      // NABLRangeFrom: "",
      // NABLRangeTo: "",
      // indx: "",
      searchMachineParameters: "",
      searchParameterMachines: "",
      searchDepartment: "",
      ParameterDepartmentList: [],
      ParameterNABLTestMethodRangeList: [],
      ShortCode: "",
      UnitID: "",
      FormulaExpression: "",
      FormulaVariables: "",
      FormulaEvaluationStatus: 0,
      ReadingCount: "1",
      ParameterSubParamtersMappingList: [],
      ShortCodeSearch: "",
      ParametersSearch: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ParameterName,
      IsNABL,
      // ParameterMaterialTypeList,
      ParameterMachineMappingList,
      ParameterMachineLinkList,
      // MaterialID,
      // MaterialText,
      // DepartmentIDEncrypt,
      // DepartmentName,
      // ProductGroupIDEncrypt,
      // ProductGroupName,
      // MaterialTypeIDEncrypt,
      // MaterialType,
      // TestMethodIDEncrypt,
      // TestMethodName,
      // NABLRangeFrom,
      // NABLRangeTo,
      // indx,
      searchMachineParameters,
      searchParameterMachines,
      searchDepartment,
      ParameterDepartmentList,
      ParameterNABLTestMethodRangeList,
      ParameterResultType,
      ParameterSubParamtersMappingList,
      FormulaExpression,
      FormulaVariables,
      FormulaEvaluationStatus,
      ParametersSearch,
      ShortCodeSearch,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      ParameterNABLTestMethodRangeList?.filter(
        (x) => x.IsDelete == false,
      )?.filter((item) => !item?.TestMethodIDEncrypt)?.length > 0
    ) {
      formik.setFieldError(
        "ParameterNABLTestMethodRangeList",
        "Please select Test Method or delete the record..",
      );
      formik.setFieldTouched("ParameterNABLTestMethodRangeList", true);
      return;
    }

    if (
      values?.ShortCode?.trim()?.toLowerCase() == "pi" ||
      values?.ShortCode?.trim()?.toLowerCase() == "e" ||
      values?.ShortCode?.trim()?.toLowerCase() == "null"
    ) {
      formik.setFieldError(
        "ShortCode",
        "'Pi', 'E' & 'NULL' can not be used as short code",
      );
      formik.setFieldTouched("ShortCode", true);
      return;
    }

    setIsLoading(true);

    let payload = {
      ParameterIDEncrypt: values?.ParameterIDEncrypt,
      ParameterName: values?.ParameterName,
      IsNABL: values?.IsNABL,
      ShortCode: values?.ShortCode,
      ParameterResultType: values?.ParameterResultType,
      // ParameterMaterialTypeList: values?.ParameterMaterialTypeList,
      DepartmentIDs: Array.from(
        values?.ParameterDepartmentList?.filter((e) => e.IsSelected == true),
        (x) => x.DepartmentIDEncrypt,
      ).join(","),
      ListOfParameterNABLTestMethodRange:
        values?.ParameterNABLTestMethodRangeList?.map((item) => {
          return {
            ...item,
            NABLRangeFrom:
              values?.ParameterResultType == 2
                ? ""
                : item?.NABLRangeFrom.toString()
                  ? item?.NABLRangeFrom.toString()
                  : item?.NABLRangeFrom.toString(),
            NABLRangeTo:
              values?.ParameterResultType == 2
                ? ""
                : item?.NABLRangeTo.toString()
                  ? item?.NABLRangeTo.toString()
                  : item?.NABLRangeTo.toString(),
            ResultValidKeywords: Array.isArray(item?.ResultValidKeywords)
              ? item.ResultValidKeywords.map((k) => k?.toString().trim())
                  .filter(Boolean)
                  .join(",")
              : item?.ResultValidKeywords || "",
          };
        }),
      ParameterMachineMappingList: values?.ParameterMachineMappingList?.filter(
        (x) =>
          x.IsSelected == true &&
          values?.ParameterMachineLinkList?.some(
            (m) => m.IsSelected && m.MachineIDEncrypt == x.MachineIDEncrypt,
          ),
      ),
      ParameterMachineLinkList: values?.ParameterMachineLinkList?.filter(
        (x) => x.IsSelected == true,
      ).map((x) => ({ MachineIDEncrypt: x.MachineIDEncrypt })),
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      UnitID: values?.UnitID ? values?.UnitID : 0,

      FormulaExpression: values?.FormulaExpression,
      FormulaVariables: values?.FormulaVariables,
      FormulaEvaluationStatus: values?.FormulaEvaluationStatus,
      ReadingCount: values?.ReadingCount == 0 ? 1 : values?.ReadingCount,
      ListOfParameterSubParamtersMapping:
        values?.ParameterSubParamtersMappingList?.filter(
          (x) => x.IsSelected == true,
        ),
    };
    console.log("payload: ", payload);
    //return;

    post(PrimaryIdParam ? POST_ParameterUpdate : POST_ParameterInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/parameters");
          }, 1000);
        } else {
          //  swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  /*START: MultiColumn */
  // const setValuesOnSelectMultiColumn = (idx) => {
  //   formik.setFieldValue(
  //     "MaterialText",
  //     materialOptions[idx]?.DepartmentName +
  //       " | " +
  //       materialOptions[idx]?.ProductGroupName +
  //       " | " +
  //       materialOptions[idx]?.MaterialType
  //   );
  //   formik.setFieldValue(
  //     "DepartmentIDEncrypt",
  //     materialOptions[idx]?.DepartmentIDEncrypt
  //   );
  //   formik.setFieldValue(
  //     "DepartmentName",
  //     materialOptions[idx]?.DepartmentName
  //   );
  //   formik.setFieldValue(
  //     "ProductGroupIDEncrypt",
  //     materialOptions[idx]?.ProductGroupIDEncrypt
  //   );
  //   formik.setFieldValue(
  //     "ProductGroupName",
  //     materialOptions[idx]?.ProductGroupName
  //   );
  //   formik.setFieldValue(
  //     "MaterialTypeIDEncrypt",
  //     materialOptions[idx]?.MaterialTypeIDEncrypt
  //   );
  //   formik.setFieldValue("MaterialType", materialOptions[idx]?.MaterialType);

  //   /*select the value when there is only one option while insert only*/
  //   if (
  //     testMethodOptions?.length == 1 &&
  //     indx == "" //Add
  //   ) {
  //     formik.setFieldValue("TestMethodIDEncrypt", testMethodOptions[0]?.value);
  //     formik.setFieldValue("TestMethodName", testMethodOptions[0]?.label);
  //   }
  // };

  // const resetValueOnUnSelectMultiColumn = () => {
  //   if (DepartmentIDEncrypt || ProductGroupIDEncrypt || MaterialTypeIDEncrypt) {
  //     formik.setFieldValue("MaterialText", "");
  //     formik.setFieldValue("DepartmentIDEncrypt", "");
  //     formik.setFieldValue("DepartmentName", "");
  //     formik.setFieldValue("ProductGroupIDEncrypt", "");
  //     formik.setFieldValue("ProductGroupName", "");
  //     formik.setFieldValue("MaterialTypeIDEncrypt", "");
  //     formik.setFieldValue("MaterialType", "");
  //     setMaterialOptions(materialOptionsList);
  //   }
  // };

  // const handleChangeMaterial = (e) => {
  //   formik.setFieldValue("MaterialText", e?.target?.value ?? "");

  //   setMaterialOptions(
  //     materialOptionsList?.filter((x) =>
  //       x.searchableText
  //         ?.toLowerCase()
  //         .includes(e?.target?.value?.toLowerCase() ?? "")
  //     )
  //   );
  // };
  /*END: MultiColumn */

  useEffect(() => {
    // getMaterialList();
    getTestMethodList();
    if (PrimaryIdParam) {
      getParameterDetails();
    } else {
      getDepartmentList();
      getMachineParameterList();
      getParameterMachineLinkList();
    }
    getUnitDDL();
    getProductGroupDDL();
    getParameterSubParamtersMappingList();
  }, []);

  const getParameterDetails = () => {
    setIsLoading(true);
    post(POST_GetParameterDetailByID, {
      ParameterIDEncrypted: window.atob(PrimaryIdParam),
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues((prevValues) => ({
            ParameterIDEncrypt: response?.ParameterIDEncrypted,
            ParameterName: response?.ParameterName,
            IsNABL: response?.IsNABL,
            ParameterResultType: response?.ParameterResultType,
            ShortCode: response?.ShortCode,
            IsActive: response?.IsActive,
            FormulaExpression: response?.FormulaExpression,
            FormulaVariables: response?.FormulaVariables,
            FormulaEvaluationStatus: response?.FormulaEvaluationStatus,
            ReadingCount: response?.ReadingCount,
            // ParameterMaterialTypeList: response?.MaterialTypeList?.map(
            //   (item) => ({
            //     ParameterMaterialTypeIDEncrypted:
            //       item.ParameterMaterialTypeIDEncrypted,
            //     MaterialName:
            //       item.DepartmentName +
            //       " | " +
            //       item.ProductGroupName +
            //       " | " +
            //       item.MaterialType,
            //     DepartmentIDEncrypt: item.DepartmentIDEncrypted,
            //     DepartmentName: item.DepartmentName,
            //     ProductGroupIDEncrypt: item.ProductGroupIDEncrypted,
            //     ProductGroupName: item.ProductGroupName,
            //     MaterialTypeIDEncrypt: item.MaterialTypeIDEncrypted,
            //     MaterialType: item.MaterialType,
            //     TestMethodIDEncrypt: item.TestMethodIDEncrypted,
            //     TestMethodName: item.TestMethod,
            //     NABLRangeFrom: item.NABLRangeFrom,
            //     NABLRangeTo: item.NABLRangeTo,
            //     IsDeleted: false,
            //   })
            // ),
            ParameterDepartmentList: response?.ParameterDepartmentList?.map(
              (item) => ({
                ...item,
                display: true,
              }),
            ),
            ParameterNABLTestMethodRangeList: (
              response?.ParameterNABLTestMethodRangeList || []
            ).map((item) => ({
              ...item,
              ResultValidKeywords: item?.ResultValidKeywords
                ? item.ResultValidKeywords.split(",")
                    .map((k) => k.trim())
                    .filter(Boolean)
                : [],
            })),
            ParameterMachineMappingList: response?.MachineMappingList?.map(
              (item) => ({
                ...item,
                display: true,
              }),
            ),
            indx: "",
            UnitID: response?.UnitID,
            // functional updater reads the live values at call time, unlike formik.values which is a stale closure here — needed since this and getParameterSubParamtersMappingList() run concurrently and either setValues call could otherwise wipe the other's field
            ParameterSubParamtersMappingList:
              prevValues.ParameterSubParamtersMappingList,
            // a machine that already has saved CSV parameters counts as ticked, so older parameters
            // (saved before Machines Mapping existed) keep their CSV mapping on the next save
            ParameterMachineLinkList: response?.MachineLinkList?.map((item) => ({
              ...item,
              IsSelected:
                item.IsSelected ||
                (response?.MachineMappingList || []).some(
                  (m) =>
                    m.IsSelected && m.MachineIDEncrypt == item.MachineIDEncrypt,
                ),
              display: true,
            })),
            searchParameterMachines: "",
          }));

          formikParameterFormula.setFieldValue(
            "FormulaExpression",
            response?.FormulaExpression,
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const addParameterMaterialType = () => {
  //   let IsValidate = true;
  //   if (
  //     !DepartmentIDEncrypt ||
  //     !ProductGroupIDEncrypt ||
  //     !MaterialTypeIDEncrypt
  //   ) {
  //     IsValidate = false;
  //     formik.setFieldError("MaterialID", "Material Type is required field");
  //     formik.setFieldTouched("MaterialID", true);
  //   }
  //   if (!TestMethodIDEncrypt) {
  //     IsValidate = false;
  //     formik.setFieldError(
  //       "TestMethodIDEncrypt",
  //       "Test Method is required field"
  //     );
  //     formik.setFieldTouched("TestMethodIDEncrypt", true);
  //   }

  //   if (
  //     ParameterMaterialTypeList?.filter(
  //       (x, i) =>
  //         x.DepartmentIDEncrypt == DepartmentIDEncrypt &&
  //         x.ProductGroupIDEncrypt == ProductGroupIDEncrypt &&
  //         x.MaterialTypeIDEncrypt == MaterialTypeIDEncrypt &&
  //         x.TestMethodIDEncrypt == TestMethodIDEncrypt &&
  //         (indx ? i != indx : 1 == 1)
  //     )?.length > 0
  //   ) {
  //     IsValidate = false;
  //     //swal("", "Data already exist!", "warning");
  //     warningMessage("Data already exist!");
  //   }
  //   if (IsValidate) {
  //     if (indx != "") {
  //       //edit
  //       let newData = ParameterMaterialTypeList;
  //       newData[indx].MaterialName = MaterialText;
  //       newData[indx].DepartmentIDEncrypt = DepartmentIDEncrypt;
  //       newData[indx].DepartmentName = DepartmentName;
  //       newData[indx].ProductGroupIDEncrypt = ProductGroupIDEncrypt;
  //       newData[indx].ProductGroupName = ProductGroupName;
  //       newData[indx].MaterialTypeIDEncrypt = MaterialTypeIDEncrypt;
  //       newData[indx].MaterialType = MaterialType;
  //       newData[indx].TestMethodIDEncrypt = TestMethodIDEncrypt;
  //       newData[indx].TestMethodName = TestMethodName;
  //       newData[indx].NABLRangeFrom = NABLRangeFrom;
  //       newData[indx].NABLRangeTo = NABLRangeTo;
  //       formik.setFieldValue("ParameterMaterialTypeList", newData);
  //     } else {
  //       //add
  //       formik.setFieldValue("ParameterMaterialTypeList", [
  //         ...ParameterMaterialTypeList,
  //         {
  //           ParameterMaterialTypeIDEncrypted: "",
  //           MaterialName: MaterialText,
  //           DepartmentIDEncrypt: DepartmentIDEncrypt,
  //           DepartmentName: DepartmentName,
  //           ProductGroupIDEncrypt: ProductGroupIDEncrypt,
  //           ProductGroupName: ProductGroupName,
  //           MaterialTypeIDEncrypt: MaterialTypeIDEncrypt,
  //           MaterialType: MaterialType,
  //           TestMethodIDEncrypt: TestMethodIDEncrypt,
  //           TestMethodName: TestMethodName,
  //           NABLRangeFrom: NABLRangeFrom,
  //           NABLRangeTo: NABLRangeTo,
  //           IsDeleted: false,
  //         },
  //       ]);
  //     }
  //     cancelParameterMaterialType();
  //   }
  // };

  // const editParameterMaterialType = (idx) => {
  //   let editData = ParameterMaterialTypeList?.filter((x, i) => i == idx)[0];
  //   formik.setFieldValue("indx", idx.toString());
  //   formik.setFieldValue("MaterialText", editData?.MaterialName);
  //   formik.setFieldValue("DepartmentIDEncrypt", editData?.DepartmentIDEncrypt);
  //   formik.setFieldValue("DepartmentName", editData?.DepartmentName);
  //   formik.setFieldValue(
  //     "ProductGroupIDEncrypt",
  //     editData?.ProductGroupIDEncrypt
  //   );
  //   formik.setFieldValue("ProductGroupName", editData?.ProductGroupName);
  //   formik.setFieldValue(
  //     "MaterialTypeIDEncrypt",
  //     editData?.MaterialTypeIDEncrypt
  //   );
  //   formik.setFieldValue("MaterialType", editData?.MaterialType);
  //   formik.setFieldValue("TestMethodIDEncrypt", editData?.TestMethodIDEncrypt);
  //   formik.setFieldValue("TestMethodName", editData?.TestMethodName);
  //   formik.setFieldValue("NABLRangeFrom", editData?.NABLRangeFrom);
  //   formik.setFieldValue("NABLRangeTo", editData?.NABLRangeTo);
  // };

  // const deleteParameterMaterialType = (idx) => {
  //   // if (ParameterMaterialTypeList?.filter((x, i) => i == idx)[0]?.ParameterMaterialTypeIDEncrypted) {
  //   //   let newData = ParameterMaterialTypeList;
  //   //   newData[idx].IsDeleted = true;
  //   //   formik.setFieldValue("ParameterMaterialTypeList", newData);
  //   // } else {
  //   formik.setFieldValue(
  //     "ParameterMaterialTypeList",
  //     ParameterMaterialTypeList?.filter((x, i) => i != idx)
  //   );
  //   // }
  //   cancelParameterMaterialType();
  // };

  // const cancelParameterMaterialType = () => {
  //   resetValueOnUnSelectMultiColumn();
  //   formik.setFieldValue("TestMethodIDEncrypt", "");
  //   formik.setFieldValue("TestMethodName", "");
  //   formik.setFieldValue("NABLRangeFrom", "");
  //   formik.setFieldValue("NABLRangeTo", "");
  //   formik.setFieldValue("indx", "");
  // };

  const handleChangeSearchMachineParameters = (e) => {
    formik.setFieldValue("searchMachineParameters", e?.target?.value);
    formik.setFieldValue(
      "ParameterMachineMappingList",
      ParameterMachineMappingList?.map((x) => {
        return {
          ...x,
          display:
            x.MachineName?.toLowerCase().includes(
              e?.target?.value?.toLowerCase(),
            ) ||
            x.MachineParameter?.toLowerCase().includes(
              e?.target?.value?.toLowerCase(),
            )
              ? true
              : false,
        };
      }),
    );
  };

  // a CSV parameter row is shown only while its machine is ticked in Machines Mapping
  const isMachineTicked = (machineIDEncrypt) =>
    ParameterMachineLinkList?.some(
      (m) => m.IsSelected && m.MachineIDEncrypt == machineIDEncrypt,
    );
  const isCsvRowVisible = (x) =>
    x.display == true && isMachineTicked(x.MachineIDEncrypt);

  const handleChangeSearchParameterMachines = (e) => {
    formik.setFieldValue("searchParameterMachines", e?.target?.value);
    formik.setFieldValue(
      "ParameterMachineLinkList",
      ParameterMachineLinkList?.map((x) => {
        const search = e?.target?.value?.toLowerCase() ?? "";
        return {
          ...x,
          display:
            x.MachineName?.toLowerCase().includes(search) ? true : false,
        };
      }),
    );
  };

  const getDepartmentList = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ParameterDepartmentList",
            response?.List?.map((item) => ({
              DepartmentIDEncrypt: item.DepartmentIDEncrypted,
              DepartmentName: item.DepartmentName,
              IsSelected: false,
              display: true,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeSearchDepartment = (e) => {
    formik.setFieldValue("searchDepartment", e?.target?.value);
    formik.setFieldValue(
      "ParameterDepartmentList",
      ParameterDepartmentList?.map((x) => {
        return {
          ...x,
          display: x.DepartmentName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase(),
          )
            ? true
            : false,
        };
      }),
    );
  };

  const AddNewNABLTestMethodRange = () => {
    formik.setFieldValue("ParameterNABLTestMethodRangeList", [
      ...ParameterNABLTestMethodRangeList,
      initNABLTestMethodRange,
    ]);
  };

  const deleteNABLTestMethodRange = (i) => {
    if (
      ParameterNABLTestMethodRangeList[i]
        ?.ParameterNABLTestMethodRangeIDEncrypted
    ) {
      formik.setFieldValue(
        `ParameterNABLTestMethodRangeList[${i}].IsDelete`,
        true,
      );
    } else {
      formik.setFieldValue(
        "ParameterNABLTestMethodRangeList",
        ParameterNABLTestMethodRangeList?.filter((x, idx) => idx != i),
      );
    }
  };

  const [showQuickAddTestMethodModal, setShowQuickAddTestMethodModal] =
    useState(false);

  const addTestMethod = () => {
    setShowQuickAddTestMethodModal(true);
  };

  const fnCallbackQuickAddTestMethod = (
    testMethodID,
    testMethodName,
    nickName,
  ) => {
    setTestMethodOptions([
      ...testMethodOptions,
      {
        label: nickName ? `${testMethodName} (${nickName})` : testMethodName,
        value: testMethodID,
        NickName: nickName,
      },
    ]);
  };

  // const validationSchemaTestMethodAdd = Yup.object().shape({
  //   TestMethodCodeType: Yup.number(),
  //   TestMethodName: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 2)
  //         return Yup.string().required("Test Method Name is required field");
  //       return schema;
  //     }
  //   ),
  //   TestMethodCountryCode: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 1)
  //         return Yup.string().required("Country Code is required field");
  //       return schema;
  //     }
  //   ),
  //   StandardCode: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 1)
  //         return Yup.string().required("Standard Code is required field");
  //       return schema;
  //     }
  //   ),
  //   Delimiter: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 1)
  //         return Yup.string().required("Delimiter is required field");
  //       return schema;
  //     }
  //   ),
  //   MethodYear: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 1)
  //         return Yup.string().required("Year is required field");
  //       return schema;
  //     }
  //   ),
  //   DisplayName: Yup.string().trim().required("Display Name is required field"),
  // });

  // const formikTestMethodAdd = useFormik({
  //   validationSchema: validationSchemaTestMethodAdd,
  //   onSubmit: (values, formikHelpers) =>
  //     handleValidSubmitTestMethodAdd(values, formikHelpers),
  //   initialValues: {
  //     TestMethodCodeType: 1,
  //     TestMethodName: "",
  //     TestMethodCountryCode: "",
  //     StandardCode: "",
  //     Delimiter: "",
  //     MethodYear: "",
  //     Description: "",
  //     TestMethodIsNABL: false,
  //     DisplayName: "",
  //     NickName: "",
  //   },
  //   validateOnBlur: false,
  // });

  // const {
  //   values: {
  //     TestMethodIsNABL,
  //     TestMethodCodeType,
  //     TestMethodCountryCode,
  //     StandardCode,
  //     Delimiter,
  //     MethodYear,
  //     DisplayName,
  //     NickName,
  //   },
  // } = formikTestMethodAdd;

  // function createTestMethodName(CountryCode, StandardCode, Delimiter, Year) {
  //   let name = "";

  //   if (CountryCode) {
  //     name += CountryCode + " ";
  //   }
  //   if (StandardCode) {
  //     name += StandardCode + " ";
  //   }
  //   if (Delimiter) {
  //     name += Delimiter + " ";
  //   }
  //   if (Year) {
  //     name += Year;
  //   }

  //   formikTestMethodAdd.setFieldValue("TestMethodName", name);
  //   //setTestMethod(name);
  // }

  // useEffect(() => {
  //   if (TestMethodCodeType == 1) {
  //     createTestMethodName(
  //       TestMethodCountryCode,
  //       StandardCode,
  //       Delimiter,
  //       MethodYear
  //     );
  //   }
  //   //formik.setFieldValue("TestMethod", testMethod);
  // }, [TestMethodCountryCode, StandardCode, Delimiter, MethodYear]);

  // const handleValidSubmitTestMethodAdd = (values) => {
  //   setIsLoading(true);
  //   let formData = new FormData();

  //   //formData.append("TestMethodIDEncrypt", values?.TestMethodIDEncrypt);
  //   formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
  //   formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
  //   formData.append("TestMethod", values?.TestMethodName.trim());
  //   formData.append("TestMethodCodeType", values?.TestMethodCodeType);
  //   formData.append("DisplayName", values?.DisplayName.trim());
  //   formData.append("NickName", values?.NickName.trim());
  //   formData.append(
  //     "TestMethodCountryCode",
  //     values?.TestMethodCountryCode ? values?.TestMethodCountryCode.trim() : ""
  //   );

  //   formData.append(
  //     "StandardCode",
  //     values?.StandardCode ? values?.StandardCode.trim() : ""
  //   );
  //   formData.append(
  //     "Delimiter",
  //     values?.Delimiter ? values?.Delimiter.trim() : ""
  //   );
  //   formData.append(
  //     "MethodYear",
  //     values?.MethodYear ? values?.MethodYear.trim() : ""
  //   );

  //   formData.append("Description", values?.Description);
  //   formData.append("IsNABL", values?.TestMethodIsNABL);
  //   formData.append(
  //     "VerificationDoneByEncrypted",
  //     AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
  //   );
  //   formData.append("TestMethodRefDocFilePathURL", "");
  //   formData.append("TestMethodRefDocFilePath", "");
  //   formData.append(
  //     "CreatedByEncrypted",
  //     AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
  //   );

  //   //console.log("Add", formData);

  //   postFormData(POST_TestMethodsInsert, formData)
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setTimeout(() => {
  //           getTestMethodList();
  //           setShowQuickAddTestMethodModal(false);
  //         }, 1000);
  //       } else {
  //         errorMessage(response?.Message);
  //         setIsLoading(false);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const [unitOptions, setUnitOptions] = useState([]);

  const getUnitDDL = () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, // Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showQuickAddCategoryModal, setShowQuickAddCategoryModal] =
    useState(false);
  const [categoryType, setCategoryType] = useState(0);
  const [parentCategoryID, setParentCategoryID] = useState(0);
  const [categoryTypeName, setCategoryTypeName] = useState("");

  const fnCallbackQuickAddCategory = (categoryID, categoryName) => {
    if (categoryType == 8) {
      // 8 = Unit
      setUnitOptions([
        {
          value: categoryID,
          label: categoryName,
        },
        ...unitOptions,
      ]);
    }
  };

  const [showParameterFormulaModal, setShowParameterFormulaModal] =
    useState(false);

  const getParameterSubParamtersMappingList = () => {
    setIsLoading(true);
    post(POST_GetParameterSubParamtersMappingList, {
      ParameterIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ParameterSubParamtersMappingList",
            response?.ParameterSubParamtersMappingList?.map((item) => ({
              SubParameterIDEncrypt: item?.SubParameterIDEncrypt,
              ParameterSubParamtersMappingIDEncrypted:
                item?.ParameterSubParamtersMappingIDEncrypted,
              SubParameterType: item?.SubParameterType,
              ParameterName: item?.ParameterName,
              ShortCode: item?.ShortCode,
              IsSelected: item?.IsSelected,
              display: true,
            })),
          );

          // formik.setFieldValue(
          //   "ParameterSubParamtersMappingList",
          //   response?.ParameterSubParamtersMappingList,
          // );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const openParameterFormulaDialog = (parameterType) => {
    setShowParameterFormulaModal(true);
  };

  const onCancelParameterFormulaDialog = () => {
    customConfirmDialog(
      "Parameter Formula",
      "Are you sure you want to cancel?",
      () => {
        setShowParameterFormulaModal(false);
      },
      true,
    );
  };

  const validationSchemaParameterFormula = Yup.object().shape({});

  const formikParameterFormula = useFormik({
    validationSchema: validationSchemaParameterFormula,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitParameterFormula(values, formikHelpers),
    initialValues: {
      //ParameterType: 0,
      ParameterName: "",
      FormulaExpression: "",
      // ParameterShortCodeList: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikParameterFormula;

  const handleValidSubmitParameterFormula = async (values) => {
    if (values?.FormulaExpression?.trim() !== "") {
      let result = await evaluateFormulaExpression(values?.FormulaExpression);
      if (result?.status == true) {
        //console.log("FormulaVariables: ", result?.FormulaVariables);

        formik.setFieldValue("FormulaExpression", values?.FormulaExpression);
        formik.setFieldValue("FormulaVariables", result?.FormulaVariables);
        formik.setFieldValue("FormulaEvaluationStatus", 1);

        setShowParameterFormulaModal(false);
      }
    } else {
      formik.setFieldValue("FormulaExpression", "");
      formik.setFieldValue("FormulaVariables", "");
      formik.setFieldValue("FormulaEvaluationStatus", 0);

      setShowParameterFormulaModal(false);
    }
  };

  const evaluateFormulaExpression = (formulaExpression) => {
    setIsLoading(true);

    let stdParaCodes = ParameterSubParamtersMappingList?.filter(
      (x) => x.ShortCode != "" && x.IsSelected == true,
    )?.map((item) => item.ShortCode);

    let shortCodeList = [...stdParaCodes];

    let testMasterShortCodes = shortCodeList?.join(",");

    return post(POST_ValidateFormulaExpression, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      FormulaExpression: formulaExpression,
      TestParametersShortCodes: testMasterShortCodes,
    })
      .then((response) => {
        setIsLoading(false);
        if (response?.IsSuccess) {
          return { status: true, FormulaVariables: response.FormulaVariables };
        } else {
          errorMessage(response?.Message);
          return { status: false, FormulaVariables: "" };
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        return { status: false, FormulaVariables: "" };
      });
  };

  const handleChangeSearchParametersName = async (
    ParametersSearchText,
    ShortCodeSearchText,
  ) => {
    let newList = ParameterSubParamtersMappingList?.filter(
      (x, ix) => x.IsSelected == true,
    );

    let newFinalList = ParameterSubParamtersMappingList?.filter(
      (x, ix) => x.IsSelected == false,
    )?.map((x) => {
      if (
        x?.ParameterName?.toLowerCase().includes(
          ParametersSearchText?.toLowerCase(),
        ) &&
        x?.ShortCode?.toLowerCase().includes(ShortCodeSearchText?.toLowerCase())
      ) {
        return { ...x, display: true };
      } else {
        return { ...x, display: false };
      }
    });

    formik.setFieldValue("ParameterSubParamtersMappingList", [
      ...newList,
      ...newFinalList,
    ]);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Standard Parameters
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={9}>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Parameter Name"
                          name="ParameterName"
                          placeholder={"Enter Parameter Name"}
                          component={CustomInput}
                          required
                          maxLength={100}
                          autoFocus
                          onChange={(e) => {
                            formik.setFieldValue(
                              "ParameterName",
                              capitalizeString(e?.target?.value),
                            );
                          }}
                        />
                      </Col>
                      <Col lg={2}>
                        {AuthUser?.UserType !== 1 ||
                        formsList?.filter((x) => x?.FormID == 17 && x?.IsAdd)
                          ?.length > 0 ? (
                          <Link
                            to="#"
                            className="icon-box icon-box-md bg-primary-light me-1"
                            title="New Unit"
                            style={{ float: "right" }}
                            onClick={() => {
                              setCategoryType(8); // 8 = Unit
                              setCategoryTypeName("Unit");
                              setParentCategoryID(0);
                              setShowQuickAddCategoryModal(true);
                            }}
                          >
                            <i className="fa fa-plus"></i>
                          </Link>
                        ) : (
                          ""
                        )}
                        <Field
                          label="Unit"
                          name="UnitID"
                          placeholder={"Select Unit"}
                          component={CustomSelect}
                          options={unitOptions}
                        />
                      </Col>
                      <Col lg={2}>
                        <label className="mb-1">
                          Short Code &nbsp;
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Short code to be used in formula. It should be
                                  unique. Constant like 'Pi', 'E' & 'NULL' can
                                  not be used as short code.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <Field
                          name="ShortCode"
                          placeholder={"Enter Short Code"}
                          component={CustomInput}
                          maxLength={50}
                          onChange={(e) => {
                            const inputValue = e?.target?.value ?? "";
                            formik.setFieldValue(
                              "ShortCode",
                              inputValue.replace(/\s+/g, ""),
                            ); //doesn't allow space
                          }}
                        />
                      </Col>

                      <Col lg={3}>
                        <Field
                          label="Parameter Result Type"
                          name="ParameterResultType"
                          placeholder={"Select Parameter Result Type"}
                          component={CustomSelect}
                          options={ParameterResultTypeOptions}
                          isClearable={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "ParameterResultType",
                              e?.value ?? "",
                            );
                          }}
                          required
                        />
                      </Col>

                      <Col lg={2}>
                        <label></label>
                        <div className="d-flex mb-2">
                          <label>NABL &nbsp;</label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckIsNABL"
                              title={IsNABL == true ? "Yes" : "No"}
                              checked={IsNABL}
                              onChange={() => {
                                formik.setFieldValue("IsNABL", !IsNABL);
                              }}
                              style={{ cursor: "pointer" }}
                            ></input>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Reading Count"
                          type="number"
                          name="ReadingCount"
                          placeholder={"Enter Reading Count"}
                          component={CustomInput}
                          numberTypeWithoutDot={true}
                          onChange={(e) => {
                            const inputValue = e?.target?.value ?? "";
                            formik.setFieldValue(
                              "ReadingCount",
                              inputValue ?? "",
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <label></label>
                        <div className="d-flex mb-2">
                          <label>Formula &nbsp;</label>
                          <Link
                            className={`icon-box icon-box-md ${
                              FormulaEvaluationStatus == 1
                                ? "bg-success"
                                : FormulaEvaluationStatus == 2
                                  ? "bg-danger"
                                  : "bg-secondary-light"
                            }`}
                            title={
                              FormulaExpression
                                ? FormulaExpression
                                : "Set Parameter Formula"
                            }
                            onClick={() => {
                              openParameterFormulaDialog(1);
                            }}
                          >
                            {SVGICON.Formula}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-1"></hr>
                    {/* <Row>
                      <Col lg={4}>
                        <Field
                          label="Material Type"
                          name="MaterialID"
                          value={MaterialText}
                          placeholder={"Select Material"}
                          component={CustomMultiColumnSelect}
                          options={materialOptions}
                          required
                          onChange={handleChangeMaterial}
                          ddlType={"Material"}
                          havingSelectedValue={
                            DepartmentIDEncrypt ||
                            ProductGroupIDEncrypt ||
                            MaterialTypeIDEncrypt
                              ? true
                              : false
                          }
                          setValuesOnSelectMultiColumn={
                            setValuesOnSelectMultiColumn
                          }
                          resetValueOnUnSelectMultiColumn={
                            resetValueOnUnSelectMultiColumn
                          }
                        />
                      </Col>
                      <Col lg={4}>
                        <Field
                          label="Test Method"
                          name="TestMethodIDEncrypt"
                          placeholder={"Select Test Method"}
                          component={CustomSelect}
                          options={testMethodOptions}
                          required
                          onChange={(e) => {
                            //console.log(e);
                            formik.setFieldValue(
                              "TestMethodIDEncrypt",
                              e?.value ?? ""
                            );
                            formik.setFieldValue(
                              "TestMethodName",
                              e?.label ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={4}>
                        <label className="mb-1">NABL Range</label>
                        <div className="d-flex">
                          <Field
                            type="number"
                            name="NABLRangeFrom"
                            placeholder={"From"}
                            component={CustomInput}
                            maxLength={100}
                          />
                          <span>&nbsp;</span>
                          <Field
                            type="number"
                            name="NABLRangeTo"
                            placeholder={"To"}
                            component={CustomInput}
                            maxLength={100}
                          />
                          <div className="ms-3">
                            <Link
                              // className="btn btn-primary btn-sm"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addParameterMaterialType();
                              }}
                            >
                              {indx !== "" ? "Update" : "Add"}
                            </Link>
                          </div>
                          {indx !== "" ? (
                            <div className="ms-1">
                              <Link
                                // className="btn btn-danger light btn-sm"
                                className="btn btn-outline-danger btn-sm me-2"
                                onClick={(e) => {
                                  cancelParameterMaterialType();
                                }}
                              >
                                Cancel
                              </Link>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col lg={4} className="mb-2">
                        <label className="mb-1">Departments</label>
                        <div
                          className="card mb-0 w-100"
                          style={{ maxHeight: "290px" }}
                        >
                          <div className="card-header p-0">
                            <input
                              type="text"
                              name="searchDepartment"
                              placeholder={"Search here..."}
                              className="form-control form-control-sm"
                              value={searchDepartment}
                              onChange={handleChangeSearchDepartment}
                              style={{
                                borderBottomLeftRadius: "0",
                                borderBottomRightRadius: "0",
                              }}
                            ></input>
                          </div>
                          <div
                            className="card-body p-0  table-responsive"
                            style={{
                              maxHeight: "260px",
                              overflow: "auto",
                            }}
                          >
                            <table className="table table-hover header-border no-footer">
                              <tbody>
                                {ParameterDepartmentList?.filter(
                                  (x) => x.display == true,
                                )?.length > 0 ? (
                                  ParameterDepartmentList?.map((item, indx) => (
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item.display == true ? "" : "none",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "center",
                                          padding: "0.5rem",
                                          width: "15%",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkDepartment${indx}`}
                                          name={`chkDepartment${indx}`}
                                          checked={item.IsSelected}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              `ParameterDepartmentList[${indx}].IsSelected`,
                                              e.target.checked,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                          padding: "0.5rem",
                                          width: "85%",
                                        }}
                                      >
                                        {item.DepartmentName}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={2}
                                      style={{ textAlign: "center" }}
                                    >
                                      <div>{"No options"}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                      {/* <Col lg={8}>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="ParameterMappingList-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="ParameterMappingList-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="4%"></th>
                                  <th width="60%">Material</th>
                                  <th width="26%">Test Method</th>
                                  <th width="10%" style={{ textAlign: "left" }}>
                                    NABL Range
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ParameterMaterialTypeList?.filter(
                                  (x) => x.IsDeleted == false
                                ).length > 0 ? (
                                  ParameterMaterialTypeList?.map(
                                    (item, idx) => (
                                      <tr
                                        style={{
                                          display:
                                            item?.IsDeleted == true
                                              ? "none"
                                              : "",
                                        }}
                                      >
                                        <td>
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-primary-light me-1"
                                            className="icon-box icon-box-md me-1"
                                            title="Edit"
                                            onClick={() => {
                                              editParameterMaterialType(idx);
                                            }}
                                          >
                                            {SVGICON.EditPrimary}
                                          </Link>
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-danger-light"
                                            className="icon-box icon-box-md me-1"
                                            title="Delete"
                                            onClick={() => {
                                              //deleteParameterMaterialType(idx);
                                              delete_RecordWithoutApi(
                                                deleteParameterMaterialType,
                                                idx
                                              );
                                            }}
                                            // onClick={() => {
                                            //   deleteParameterMaterialType(idx);
                                            // }}
                                          >
                                            {SVGICON.DeleteDanger}
                                          </Link>
                                        </td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          className="popupOverlay"
                                        >
                                          <OverlayTrigger
                                            trigger={['hover', 'focus']}
                                            key={indx}
                                            responsive={true}
                                            overlay={
                                              <Tooltip
                                                className="toltip-popover"
                                                // id={`popover-positioned-${item.MaterialName.toLowerCase()}`}
                                              >
                                                <strong className="p-1">
                                                  {item.MaterialName}
                                                </strong>
                                              </Tooltip>
                                            }
                                          >
                                            <span>{item.MaterialName}</span>
                                          </OverlayTrigger>
                                        </td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          className="popupOverlay"
                                        >
                                          <OverlayTrigger
                                            trigger={['hover', 'focus']}
                                            key={indx}
                                            responsive={true}
                                            overlay={
                                              <Tooltip
                                                className="toltip-popover"
                                                // id={`popover-positioned-${item.TestMethodName.toLowerCase()}`}
                                              >
                                                <strong className="p-1">
                                                  {item.TestMethodName}
                                                </strong>
                                              </Tooltip>
                                            }
                                          >
                                            <span>{item.TestMethodName}</span>
                                          </OverlayTrigger>
                                        </td>
                                        <td style={{ textAlign: "left" }}>
                                          {item.NABLRangeFrom
                                            ? item.NABLRangeFrom +
                                              " - " +
                                              item.NABLRangeTo
                                            : ""}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col> */}
                      {/* {IsNABL == true && ( */}
                      <Col lg={8}>
                        <div>
                          <label>Parameter Test Methods</label>
                          {AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 20 && x?.IsAdd)
                            ?.length > 0 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New Test Method"
                              style={{ float: "right" }}
                              onClick={addTestMethod}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="ParameterMappingList-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="ParameterMappingList-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="4%">
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md bg-primary-light"
                                      title="Add New"
                                      onClick={() => {
                                        AddNewNABLTestMethodRange();
                                      }}
                                    >
                                      <i className="fa fa-plus"></i>
                                    </Link>
                                  </th>
                                  <th width="18%">Material Group</th>
                                  <th width="34%">Test Method</th>
                                  <th width="22%" style={{ textAlign: "left" }}>
                                    NABL Range
                                  </th>
                                  <th width="22%" style={{ textAlign: "left" }}>
                                    Result Valid Keywords
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ParameterNABLTestMethodRangeList?.filter(
                                  (x) => x.IsDelete == false,
                                ).length > 0 ? (
                                  ParameterNABLTestMethodRangeList?.map(
                                    (item, idx) => (
                                      <tr
                                        key={idx}
                                        style={{
                                          display:
                                            item?.IsDelete == true
                                              ? "none"
                                              : "",
                                        }}
                                      >
                                        <td className="p-1">
                                          <Link
                                            to="#"
                                            className="icon-box icon-box-md"
                                            title="Delete"
                                            onClick={() => {
                                              delete_RecordWithoutApi(
                                                deleteNABLTestMethodRange,
                                                idx,
                                              );
                                            }}
                                          >
                                            {SVGICON.DeleteDanger}
                                          </Link>
                                        </td>
                                        <td className="p-1">
                                          <Field
                                            name={`ParameterNABLTestMethodRangeList[${idx}].ProductGroupIDEncrypt`}
                                            placeholder={
                                              "Select Material Group"
                                            }
                                            options={productGroupOptions}
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                            onChange={(e) => {
                                              if (e) {
                                                if (
                                                  ParameterNABLTestMethodRangeList?.filter(
                                                    (x) => x.IsDelete == false,
                                                  )?.filter(
                                                    (itemP, index) =>
                                                      itemP?.ProductGroupIDEncrypt ==
                                                        e?.value &&
                                                      itemP.TestMethodIDEncrypt ==
                                                        item.TestMethodIDEncrypt &&
                                                      idx != index,
                                                  )?.length > 0
                                                ) {
                                                  warningMessage(
                                                    "Selected Material Group already Exist...!",
                                                  );
                                                  formik.setFieldValue(
                                                    `ParameterNABLTestMethodRangeList[${idx}].ProductGroupIDEncrypt`,
                                                    "",
                                                  );
                                                } else {
                                                  formik.setFieldValue(
                                                    `ParameterNABLTestMethodRangeList[${idx}].ProductGroupIDEncrypt`,
                                                    e?.value,
                                                  );
                                                }
                                              } else {
                                                formik.setFieldValue(
                                                  `ParameterNABLTestMethodRangeList[${idx}].ProductGroupIDEncrypt`,
                                                  "",
                                                );
                                              }
                                            }}
                                          />
                                        </td>
                                        <td>
                                          <Field
                                            name={`ParameterNABLTestMethodRangeList[${idx}].TestMethodIDEncrypt`}
                                            placeholder={"Select Test Method"}
                                            options={testMethodOptions}
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                            onChange={(e) => {
                                              if (e) {
                                                if (
                                                  ParameterNABLTestMethodRangeList?.filter(
                                                    (x) => x.IsDelete == false,
                                                  )?.filter(
                                                    (itemP, index) =>
                                                      itemP?.TestMethodIDEncrypt ==
                                                        e?.value &&
                                                      itemP.ProductGroupIDEncrypt ==
                                                        item.ProductGroupIDEncrypt &&
                                                      idx != index,
                                                  )?.length > 0
                                                ) {
                                                  warningMessage(
                                                    "Selected Test Method already Exist...!",
                                                  );
                                                  formik.setFieldValue(
                                                    `ParameterNABLTestMethodRangeList[${idx}].TestMethodIDEncrypt`,
                                                    "",
                                                  );
                                                } else {
                                                  formik.setFieldValue(
                                                    `ParameterNABLTestMethodRangeList[${idx}].TestMethodIDEncrypt`,
                                                    e?.value,
                                                  );
                                                }
                                              } else {
                                                formik.setFieldValue(
                                                  `ParameterNABLTestMethodRangeList[${idx}].TestMethodIDEncrypt`,
                                                  "",
                                                );
                                              }
                                            }}
                                          />
                                        </td>
                                        <td style={{ textAlign: "left" }}>
                                          <div className="d-flex">
                                            <Field
                                              type="number"
                                              name={`ParameterNABLTestMethodRangeList[${idx}].NABLRangeFrom`}
                                              placeholder={"From"}
                                              component={CustomInput}
                                              maxLength={100}
                                              noMarginBottom={true}
                                              disabled={
                                                ParameterResultType == 2
                                                  ? true
                                                  : false
                                              }
                                              // onChange={(e) => {
                                              //   if (e?.target?.value > 0) {
                                              //     formik.setFieldValue(
                                              //       `ParameterNABLTestMethodRangeList[${idx}].NABLRangeFrom`,
                                              //       e?.target?.value
                                              //     );
                                              //   } else {
                                              //     formik.setFieldValue(
                                              //       `ParameterNABLTestMethodRangeList[${idx}].NABLRangeFrom`,
                                              //       ""
                                              //     );
                                              //   }
                                              // }}
                                            />
                                            <span>&nbsp;</span>
                                            <Field
                                              type="number"
                                              name={`ParameterNABLTestMethodRangeList[${idx}].NABLRangeTo`}
                                              placeholder={"To"}
                                              component={CustomInput}
                                              maxLength={100}
                                              noMarginBottom={true}
                                              disabled={
                                                ParameterResultType == 2
                                                  ? true
                                                  : false
                                              }
                                              // onChange={(e) => {
                                              //   if (e?.target?.value > 0) {
                                              //     formik.setFieldValue(
                                              //       `ParameterNABLTestMethodRangeList[${idx}].NABLRangeTo`,
                                              //       e?.target?.value
                                              //     );
                                              //   } else {
                                              //     formik.setFieldValue(
                                              //       `ParameterNABLTestMethodRangeList[${idx}].NABLRangeTo`,
                                              //       ""
                                              //     );
                                              //   }
                                              // }}
                                            />
                                          </div>
                                        </td>

                                        <td className="p-1">
                                          <Field
                                            name={`ParameterNABLTestMethodRangeList[${idx}].ResultValidKeywords`}
                                            placeholder={"Add keyword"}
                                            component={CustomTagsInput}
                                            noMarginBottom={true}
                                            onlyUnique={true}
                                            addOnBlur={true}
                                            addKeys={[9, 13, 188]}
                                            inputProps={{
                                              placeholder: "Add keyword",
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    ),
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <ErrorMessage
                          name={"ParameterNABLTestMethodRangeList"}
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </Col>
                      {/* )} */}
                    </Row>
                  </Col>
                  <Col lg={3}>
                    <Row>
                      <Col lg={12} className="mb-2">
                        <label className="mb-1">Machines Mapping</label>
                        <div className="card mb-0 w-100">
                          <div className="card-header p-0">
                            <input
                              type="text"
                              name="searchParameterMachines"
                              placeholder={"Search here..."}
                              className="form-control form-control-sm"
                              value={searchParameterMachines}
                              onChange={handleChangeSearchParameterMachines}
                              style={{
                                borderBottomLeftRadius: "0",
                                borderBottomRightRadius: "0",
                              }}
                            ></input>
                          </div>
                          <div
                            className="card-body p-0 table-responsive"
                            style={{
                              maxHeight: "220px",
                              overflow: "auto",
                            }}
                          >
                            <table className="table table-hover header-border no-footer">
                              <tbody>
                                {ParameterMachineLinkList?.filter(
                                  (x) => x.display == true,
                                )?.length > 0 ? (
                                  ParameterMachineLinkList?.map((item, idx) => (
                                    <tr
                                      key={idx}
                                      style={{
                                        display:
                                          item.display == true ? "" : "none",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "center",
                                          padding: "0.5rem",
                                          width: "12%",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkParameterMachine${idx}`}
                                          name={`chkParameterMachine${idx}`}
                                          checked={item.IsSelected}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              `ParameterMachineLinkList[${idx}].IsSelected`,
                                              e.target.checked,
                                            );
                                            // unticking a machine also clears its CSV parameter selections
                                            if (!e.target.checked) {
                                              formik.setFieldValue(
                                                "ParameterMachineMappingList",
                                                ParameterMachineMappingList?.map(
                                                  (x) =>
                                                    x.MachineIDEncrypt ==
                                                    item.MachineIDEncrypt
                                                      ? { ...x, IsSelected: false }
                                                      : x,
                                                ),
                                              );
                                            }
                                          }}
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                          padding: "0.5rem",
                                          width: "88%",
                                        }}
                                      >
                                        <span>{item.MachineName}</span>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={2}
                                      style={{ textAlign: "center" }}
                                    >
                                      <div>{"No options"}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12} className="mb-2">
                        <label className="mb-1">
                          Machine CSV Parameters Mapping
                        </label>
                        <div className="card mb-0 w-100">
                          <div className="card-header p-0">
                            <input
                              type="text"
                              name="searchMachineParameters"
                              placeholder={"Search here..."}
                              className="form-control form-control-sm"
                              value={searchMachineParameters}
                              onChange={handleChangeSearchMachineParameters}
                              style={{
                                borderBottomLeftRadius: "0",
                                borderBottomRightRadius: "0",
                              }}
                            ></input>
                          </div>
                          <div
                            className="card-body p-0 table-responsive"
                            style={{
                              maxHeight: "250px",
                              overflow: "auto",
                            }}
                          >
                            <table className="table table-hover header-border no-footer">
                              <tbody>
                                {ParameterMachineMappingList?.filter(
                                  (x) => isCsvRowVisible(x),
                                )?.length > 0 ? (
                                  ParameterMachineMappingList?.map(
                                    (item, idx) => (
                                      <tr
                                        key={idx}
                                        style={{
                                          display: isCsvRowVisible(item)
                                            ? ""
                                            : "none",
                                        }}
                                      >
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "0.5rem",
                                            width: "12%",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`chkMachineParameter${idx}`}
                                            name={`chkMachineParameter${idx}`}
                                            checked={item.IsSelected}
                                            onChange={(e) => {
                                              formik.setFieldValue(
                                                `ParameterMachineMappingList[${idx}].IsSelected`,
                                                e.target.checked,
                                              );
                                            }}
                                          />
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "left",
                                            padding: "0.5rem",
                                            width: "88%",
                                          }}
                                        >
                                          <span>{item.MachineParameter}</span>
                                          <span
                                            style={{
                                              fontSize: "9px",
                                              display: "block",
                                            }}
                                          >
                                            {item.MachineName}
                                          </span>
                                        </td>
                                      </tr>
                                    ),
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={2}
                                      style={{ textAlign: "center" }}
                                    >
                                      <div>
                                        {ParameterMachineLinkList?.some(
                                          (m) => m.IsSelected,
                                        )
                                          ? "No options"
                                          : "Select machines in Machines Mapping first"}
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>

        <QuickAddTestMethod
          showModal={showQuickAddTestMethodModal}
          setShowModal={setShowQuickAddTestMethodModal}
          fnCallback={fnCallbackQuickAddTestMethod}
        />

        <Modal
          className="fade"
          show={showParameterFormulaModal}
          onHide={setShowParameterFormulaModal}
          size="lg"
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikParameterFormula}>
              <Form onSubmit={formikParameterFormula.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    Parameter Formula {" - "}
                    {ParameterName}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div>
                        <label>Select Sub Parameter</label>
                      </div>
                      <div
                        className="table-responsive active-projects style-1 shorting"
                        style={{ maxHeight: "450px" }}
                      >
                        <div
                          id="TestParameters-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="TestParameters-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="3%" className="ps-1"></th>
                                <th width="33%">Parameters</th>

                                <th width="30%" style={{ textAlign: "left" }}>
                                  Short Code
                                </th>
                              </tr>
                              <tr>
                                <th className="p-1 pt-0"></th>
                                <th width="20%" className="p-1 pt-0">
                                  <Field
                                    name="ParametersSearch"
                                    placeholder={"Search Parameters"}
                                    component={CustomInput}
                                    required
                                    maxLength={100}
                                    noMarginBottom={true}
                                    style={{ height: "2rem" }}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "ParametersSearch",
                                        e?.target?.value ?? "",
                                      );

                                      handleChangeSearchParametersName(
                                        e?.target?.value ?? "",
                                        ShortCodeSearch ? ShortCodeSearch : "",
                                      );
                                    }}
                                  />
                                </th>
                                <th width="15%" className="p-1 pt-0">
                                  <Field
                                    name="ShortCodeSearch"
                                    placeholder={"Search Short Code"}
                                    component={CustomInput}
                                    required
                                    maxLength={100}
                                    noMarginBottom={true}
                                    style={{ height: "2rem" }}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "ShortCodeSearch",
                                        e?.target?.value ?? "",
                                      );

                                      handleChangeSearchParametersName(
                                        ParametersSearch
                                          ? ParametersSearch
                                          : "",
                                        e?.target?.value ?? "",
                                      );
                                    }}
                                  />
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ParameterSubParamtersMappingList?.filter(
                                (x) => x.display == true,
                              )?.length > 0 ? (
                                ParameterSubParamtersMappingList?.map(
                                  (para, iPara) => (
                                    <tr
                                      key={`para_${iPara}`}
                                      style={{
                                        display:
                                          para.display == true ? "" : "none",
                                      }}
                                    >
                                      <td className="p-1">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkIsSelected${iPara}`}
                                          name={`chkIsSelected${iPara}`}
                                          checked={para.IsSelected}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              `ParameterSubParamtersMappingList[${iPara}].IsSelected`,
                                              e?.target?.checked,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td className="p-1">
                                        {para?.ParameterName}
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                        }}
                                      >
                                        {para?.ShortCode}
                                      </td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={5}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="card mb-3" style={{ height: "auto" }}>
                        <div className="card-header p-2 ps-3 pb-0">
                          <label>Short Codes</label>
                        </div>
                        <div className="card-body fs-14 pt-1 pb-2">
                          <ul className="unorder-list ps-3 row">
                            <li className="col-lg-4 ps-1">
                              <span className="text-primary">
                                <b>Pi</b>
                              </span>
                              <span className="fs-13"> - Constant (π)</span>
                            </li>

                            <li className="col-lg-4 ps-1">
                              <span className="text-primary">
                                <b>E</b>
                              </span>
                              <span className="fs-13"> - Constant (e)</span>
                            </li>
                            <li className="col-lg-4 ps-1">
                              <span className="text-primary">
                                <b>NULL</b>
                              </span>
                              <span className="fs-13"> - Constant (NULL)</span>
                            </li>
                            {ParameterSubParamtersMappingList?.length > 0
                              ? ParameterSubParamtersMappingList?.filter(
                                  (x) =>
                                    x.ShortCode != "" && x.IsSelected == true,
                                )?.map((p) => (
                                  <li className="col-lg-4 ps-1">
                                    <span className="text-primary">
                                      <b>{p.ShortCode}</b>
                                    </span>
                                    <span className="fs-13">
                                      {" - "} {p.ParameterName}
                                    </span>
                                  </li>
                                ))
                              : ""}
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <Field
                        label={`Formula Expression for ${ParameterName}`}
                        name="FormulaExpression"
                        placeholder={"Enter Formula Expression"}
                        component={CustomTextArea}
                        rows={4}
                        maxLength={2000}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button type="submit" variant="primary btn-sm">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    variant="danger btn-sm"
                    onClick={onCancelParameterFormulaDialog}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        {/* <Modal
          className="fade"
          show={showQuickAddTestMethodModal}
          onHide={setShowQuickAddTestMethodModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestMethodAdd}>
              <Form onSubmit={formikTestMethodAdd.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Test Method</Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowQuickAddTestMethodModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <label>
                        Name <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col lg={12}>
                      <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="customRadioStandard"
                          name="TestMethodCodeType"
                          title="Standard Name"
                          style={{ cursor: "pointer" }}
                          checked={TestMethodCodeType == 1 ? true : false}
                          onClick={() => {
                            formikTestMethodAdd.setFieldValue(
                              "TestMethodCodeType",
                              1
                            );
                            formikTestMethodAdd.setFieldValue(
                              "TestMethodName",
                              ""
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customRadioStandard"
                        >
                          Standard Name
                        </label>
                      </div>
                      <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="customRadioManual"
                          name="TestMethodCodeType"
                          title="Manual"
                          style={{ cursor: "pointer" }}
                          checked={TestMethodCodeType == 2 ? true : false}
                          onClick={() => {
                            formikTestMethodAdd.setFieldValue(
                              "TestMethodCodeType",
                              2
                            );
                            formikTestMethodAdd.setFieldValue(
                              "TestMethodCountryCode",
                              ""
                            );
                            formikTestMethodAdd.setFieldValue(
                              "StandardCode",
                              ""
                            );
                            formikTestMethodAdd.setFieldValue("Delimiter", "");
                            formikTestMethodAdd.setFieldValue("MethodYear", "");
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customRadioManual"
                        >
                          Manual
                        </label>
                      </div>
                    </Col>
                    {TestMethodCodeType == 1 ? (
                      <Col lg={12}>
                        <Row>
                          <Col lg={4} className="pe-zero">
                            <Field
                              label="Country Code"
                              name="TestMethodCountryCode"
                              placeholder={"Enter Country Code"}
                              component={CustomInput}
                              required
                              maxLength={4}
                              disabled={TestMethodCodeType == 2 ? true : false}
                            />
                          </Col>
                          <Col lg={4} className="pe-zero">
                            <Field
                              label="Standard Code"
                              name="StandardCode"
                              placeholder={"Enter Standard Code"}
                              component={CustomInput}
                              required
                              maxLength={4}
                              disabled={TestMethodCodeType == 2 ? true : false}
                            />
                          </Col>
                          <Col lg={2} className="pe-zero">
                            <Field
                              label="Delimiter"
                              name="Delimiter"
                              placeholder={"Delimiter"}
                              component={CustomInput}
                              required
                              maxLength={4}
                              disabled={TestMethodCodeType == 2 ? true : false}
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Year"
                              name="MethodYear"
                              placeholder={"Year"}
                              component={CustomInput}
                              required
                              maxLength={4}
                              disabled={TestMethodCodeType == 2 ? true : false}
                            />
                          </Col>
                        </Row>
                      </Col>
                    ) : (
                      ""
                    )}
                    <Col lg={12}>
                      <Field
                        // label="Test Method Name"
                        name="TestMethodName"
                        placeholder={"Enter Test Method Name"}
                        component={CustomInput}
                        required
                        maxLength={100}
                        disabled={TestMethodCodeType == 1 ? true : false}
                        onChange={(e) => {
                          formikTestMethodAdd.setFieldValue(
                            "TestMethodName",
                            capitalizeString(e?.target?.value)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Description"
                        name="Description"
                        placeholder={"Enter Description"}
                        component={CustomTextArea}
                        rows={3}
                        maxLength={100}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Display Name"
                        name="DisplayName"
                        placeholder={"Enter Display Name"}
                        component={CustomInput}
                        required
                        maxLength={500}
                        onChange={(e) => {
                          formikTestMethodAdd.setFieldValue(
                            "DisplayName",
                            capitalizeString(e?.target?.value)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Nick Name"
                        name="NickName"
                        placeholder={"Enter Nick Name"}
                        component={CustomInput}
                        maxLength={500}
                      />
                    </Col>
                    <Col lg={12}>
                      <div className="d-flex mb-2">
                        <label>NABL &nbsp;</label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            title={TestMethodIsNABL == true ? "Yes" : "No"}
                            checked={TestMethodIsNABL}
                            onChange={() => {
                              formikTestMethodAdd.setFieldValue(
                                "TestMethodIsNABL",
                                !TestMethodIsNABL
                              );
                            }}
                            style={{ cursor: "pointer" }}
                          ></input>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    // className="btn me-2 btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={() => setShowQuickAddTestMethodModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal> */}
        <QuickAddCategory
          categoryType={categoryType}
          parentCategoryID={parentCategoryID}
          showModal={showQuickAddCategoryModal}
          setShowModal={setShowQuickAddCategoryModal}
          categoryTypeName={categoryTypeName}
          fnCallback={fnCallbackQuickAddCategory}
        />
      </div>
    </div>
  );
};

export default AddParameters;
